import { supabase } from './supabase';
import { fetchFeeProducts, type FeeProduct } from './order-fees';

/**
 * Toeslag/kosten op offerte-niveau (Bijrijdertoeslag, Transportkosten, …).
 * De keuzelijst is identiek aan de order-kant (zelfde Wasserij fee-producten),
 * dus we hergebruiken `fetchFeeProducts` uit order-fees. Toevoegen gaat via de
 * Lead_Product__c-mutatie-endpoint met action 'fee-add'.
 */
export { fetchFeeProducts };
export type { FeeProduct };

export interface OfferteFeeAddResult {
  success: boolean;
  message?: string;
  errorCode?: string;
  leadProductId?: string | null;
}

async function authHeaders(): Promise<Record<string, string>> {
  const { data: { session } } = await supabase.auth.getSession();
  const h: Record<string, string> = { 'Content-Type': 'application/json' };
  if (session?.access_token) h['Authorization'] = `Bearer ${session.access_token}`;
  return h;
}

export interface AddOfferteFeeArgs {
  leadId: string;
  productId: string;
  quantity: number;
}

export async function addOfferteFee(args: AddOfferteFeeArgs): Promise<OfferteFeeAddResult> {
  const headers = await authHeaders();
  const response = await fetch('/api/offertes/lead-product', {
    method: 'POST',
    headers,
    body: JSON.stringify({
      action: 'fee-add',
      leadId: args.leadId,
      productId: args.productId,
      // quantity reist mee in het bestaande `aantal`-veld (# stuks toeslag).
      aantal: args.quantity,
      bron: 'Office-App',
    }),
  });
  const data = await response.json().catch(() => ({} as Record<string, unknown>));
  if (!response.ok && data.success !== true) {
    return {
      success: false,
      message: (data.error as string) || (data.message as string) || `Toeslag toevoegen mislukt (${response.status})`,
      errorCode: data.errorCode as string | undefined,
    };
  }
  return {
    success: data.success === true,
    leadProductId: (data.leadProductId as string | null) ?? null,
  };
}
